export interface StatisticState {
  pushStatisticDetail: PushDetailItem[];
  pushStatisticDetailFlag?: string;

  pushStatisticGroup: PushGroupItem[];
  pushMessageCount: number;
  pushGroupings: {
    pushGroupBy: string[];
    pushGroupByOptionally: string[];
    pushGroupIncoming: string[];
  };

  pushSubscribers?: PushSubscriberItem[],
  pushHistories?: PushHistoryItem[],
}

// - - -

export interface PushDetailItem {
  id: string;
  create_date: string;
  application: string;
  recipient: string;
  partner: string;
  os?: string;
  message?: string;
  status: string;
  error_code: number;
}

export class PushDetailItemInfo {
  id: string|null = null;
  transport_message_id?: string;
  create_date: string|null = null;
  sent_date?: string;
  delivery_date?: string;
  defer_date?: string;
  read_date?: string;
  expire_date?: string;
  external_id?: string;
  application: string|null = null;
  app_version?: string;
  os?: string;
  os_version?: string;
  sdk_version?: string;
  recipient: string|null = null;
  device: string|null = null;
  parent_message_id?: string;
  parent_message_transport?: string;
  bulk_id?: number;
  partner: string|null = null;
  partner_user_login?: string;
  status: string|null = null;
  error_code?: number;
  error_description?: string;
  message_type?: string;
  title: string|null = null;
  message: string|null = null;
  content?: string;
  content_load_date?: string;
  priority?: number;
  partner_price?: string;
  broker_account_login?: string;
  template_id?: number;
  connection_type?: string;
  ext_id1?: string;
  ext_id2?: string;
  ext_id3?: string;
  ext_id4?: string;
  ext_id5?: string;
}

export class PushDetailFilterParams {
  date_from: string;
  date_to: string;
  application?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  os?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  sent_date_from?: string = undefined;
  sent_date_to?: string = undefined;
  deliver_date_from?: string = undefined;
  deliver_date_to?: string = undefined;
  bulk_id?: number = undefined;
  template_id?: number = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  transport_message_id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mt";
  }
}

// - - -

export interface PushGroupItem {
  date?: string;
  application?: string;
  os?: string;
  partner?: string;
  template_id?: number;
  bulk_id?: number;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  failed: number;
  rejected: number;
  expired: number;
  deferred: number;
  total: number;
  partner_price: string;
}

export class PushGroupFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  application?: string = undefined;
  os?: string = undefined;
  partner?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}

export interface PushSubscriberItem {
  date?: string;
  android_count?: number;
  ios_count?: number;
}

export interface PushHistoryItem {
  date: string;
  application: string;
  os: string;
  subscriptions_count: number;
  unsubscriptions_count: number;
}

export class PushHistoryFilterParams {
  date_from: string;
  date_to: string;
  application?: string = undefined;
  os?: string = undefined;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}
